"use client";
import { UserContext } from "@dev-apps/common-ui-components";
import React from "react";

export default function SessionHandler({ appType, children }) {
  function routeToLogin() {
    if (appType === "public") {
      window.location.href = `${process.env.NEXT_PUBLIC_BASE_URL}/sewppublic/login`;
    } else if (appType === "internal"){
      window.location.href = `${process.env.NEXT_PUBLIC_BASE_URL}/sewpinternal/login`;
    } else if (appType === "chop") {
      window.location.href = `${process.env.NEXT_PUBLIC_BASE_URL}/sewpchop/login`;
    } else if (appType === "prop") {
      window.location.href = `${process.env.NEXT_PUBLIC_BASE_URL}/sewpprop/login`;
    }
    // no "else" since we don't want to accidentally navigate to a login page that isn't specfific to the app. 
  }
  return (
    <UserContext onRefreshError={routeToLogin}>
      {children}
    </UserContext>
  );
}